import PythonMainPage from '../containers/HomeDemo1'

const HomeDemo1 = () => {

  return (
    <>
      <PythonMainPage />
    </>
  );
}

export default HomeDemo1;

